module.exports = __webpack_public_path__ + "img/tips.a1dcfff1.png";